module.exports = __webpack_public_path__ + "static/img/013 2.7c2491ad.jpg";